import Facebook from './facebook'
import Instagram from './instagram'

export default {
  facebook: Facebook,
  instagram: Instagram,
}
